import { Box } from '@mui/material';
import type { StrapiSliderBlock } from '../types';

interface SliderBlockProps {
  block: StrapiSliderBlock;
}

export const SliderBlock = ({ block }: SliderBlockProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '16px',
        overflow: 'auto',
        paddingY: '8px',
      }}
    >
      {block.files.map((file, fileIndex) => (
        <Box
          key={fileIndex}
          component="img"
          src={file.url}
          alt={file.alternativeText || ''}
          sx={{
            height: '300px',
            width: 'auto',
            borderRadius: '8px',
            flexShrink: 0,
          }}
        />
      ))}
    </Box>
  );
};
